/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Lead
 *
 * 1 = NewDealSetup
 *
 * 2 = Appraisal
 *
 * 3 = EnquiryCRM
 *
 * 4 = EnquiryManagement
 *
 * 5 = Reservation
 *
 * 6 = Appointment
 *
 * 7 = Autotrader
 */
export enum EnquiryCreatedSource {
  Lead = 0,
  NewDealSetup = 1,
  Appraisal = 2,
  EnquiryCRM = 3,
  EnquiryManagement = 4,
  Reservation = 5,
  Appointment = 6,
  Autotrader = 7,
}
